import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import Content from '../components/layout/Content';
import Portlet from '../components/utils/Portlet';
import Loader from '../components/utils/Loader';
import ErrorContainer from '../components/utils/ErrorContainer';
import DateSelect from '../components/utils/DateSelect';
import PointsSelect from '../components/utils/PointsSelect';
import HeatGrid, { buildCells } from '../components/delivery-map/HeatGrid';
import HeatLegend from '../components/delivery-map/HeatLegend';
import MapHeightContainer from '../components/delivery-map/MapHeightContainer';
import BranchesTable from '../components/delivery-map/BranchesTable';
import {
    fetchDeliveryPoints,
    fetchDeliveryZones,
    setDeliveryFilters,
    setDeliveryCellSize,
    setDeliveryMetric,
    setDeliveryShowZones
} from '../action/delivery-map';
import { setUIvisible } from '../action/UImobile';

const styles = {
    loading: {
        minHeight: '500px',
        display: 'flex',
        justifyContent: 'center'
    }
};

const CELL_SIZE_OPTIONS = [
    { value: 1000, label: '1 км' },
    { value: 500, label: '500 м' },
    { value: 250, label: '250 м' },
    { value: 150, label: '150 м' },
    { value: 100, label: '100 м' },
    { value: 50, label: '50 м' }
];

const METRIC_OPTIONS = [
    { value: 'count', label: 'По количеству' },
    { value: 'revenue', label: 'По выручке' }
];

class DeliveryMap extends Component {
    componentDidMount() {
        this.props.setUIvisible(true, false);
    }

    onChangeDateSelect = ({ min, max }) => {
        const { filters } = this.props;
        this.props.setDeliveryFilters({ ...filters, createdStartDate: min, createdEndDate: max });
    };

    onChangePoints = (data) => {
        const { filters, showZones } = this.props;
        const nextFilters = { ...filters, points: data || [] };
        this.props.setDeliveryFilters(nextFilters);
        if (showZones) this.props.fetchDeliveryZones(nextFilters);
    };

    onChangeShowZones = (e) => {
        const showZones = e.target.checked;
        this.props.setDeliveryShowZones(showZones);
        if (showZones) this.props.fetchDeliveryZones();
    };

    onSearch = () => {
        this.props.fetchDeliveryPoints();
        if (this.props.showZones) this.props.fetchDeliveryZones();
    };

    resetFilter = () => {
        const { filters, showZones } = this.props;
        const nextFilters = { ...filters, points: [] };
        this.props.setDeliveryFilters(nextFilters);
        this.props.fetchDeliveryPoints();
        if (showZones) this.props.fetchDeliveryZones(nextFilters);
    };

    renderSubHeader() {
        const { summary } = this.props;
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Карта заказов</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                        <div className="kt-subheader__group">
                            <span className="kt-subheader__desc">
                                Заказов: {summary.count} · Выручка: {Math.round(summary.revenue).toLocaleString('ru-RU')} ₽
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const { filters, points, zones, filials, branches, cellSize, metric, showZones, loading } = this.props;

        const { maxValue } = buildCells(points, cellSize, metric);

        return (
            <Content>
                <div className="delivery-map-page">
                    {this.renderSubHeader()}
                    <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid delivery-map-page__container">
                        <div className="kt-portlet__body delivery-map-page__filters">
                            <div className="kt-form kt-form--label-right kt-margin-t-5 kt-margin-b-5">
                                <div className="filterBlocks">
                                    <div style={{ width: 200 }}>
                                        <DateSelect
                                            width={200}
                                            optionsDate={{ tommorow: true, period: true, prevWeek: true, prevMonth: true }}
                                            limit={{ field: 'months', value: 6 }}
                                            onChange={this.onChangeDateSelect}
                                        />
                                    </div>
                                    <PointsSelect
                                        width={220}
                                        placeholder="Филиалы"
                                        values={filters.points}
                                        setData={this.onChangePoints}
                                    />
                                    <div className="delivery-map-page__zones-toggle">
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={showZones}
                                                onChange={this.onChangeShowZones}
                                            />
                                            <span>Зоны доставки</span>
                                        </label>
                                    </div>
                                    <div>
                                        <button style={{ marginRight: 5 }} onClick={this.onSearch} className="btn btn-primary">Найти</button>
                                        <button onClick={this.resetFilter} className="btn btn-danger">Сбросить</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Portlet fit={true} style={{ marginBottom: 0 }} className="delivery-map-page__portlet">
                            <ErrorContainer field="deliveryMap" style={{ margin: 15 }} hasCloseButton={true} />
                            <div className="delivery-map-page__content">
                                <div className="filterBlocks delivery-map-page__controls" style={{ marginBottom: 10 }}>
                                    <div style={{ width: 150 }}>
                                        <Select
                                            value={CELL_SIZE_OPTIONS.find((item) => item.value === cellSize)}
                                            closeMenuOnSelect={true}
                                            onChange={(option) => this.props.setDeliveryCellSize(option.value)}
                                            options={CELL_SIZE_OPTIONS}
                                            placeholder="Размер ячейки"
                                        />
                                    </div>
                                    <div style={{ width: 180 }}>
                                        <Select
                                            value={METRIC_OPTIONS.find((item) => item.value === metric)}
                                            closeMenuOnSelect={true}
                                            onChange={(option) => this.props.setDeliveryMetric(option.value)}
                                            options={METRIC_OPTIONS}
                                            placeholder="Раскраска"
                                        />
                                    </div>
                                </div>
                                {loading ? (
                                    <div style={styles.loading}><Loader /></div>
                                ) : (
                                    <React.Fragment>
                                        <MapHeightContainer>
                                            {(mapHeight) => (
                                                <HeatGrid
                                                    points={points}
                                                    zones={showZones ? zones : []}
                                                    filials={filials}
                                                    fitZones={Boolean(filters.points && filters.points.length)}
                                                    cellSize={cellSize}
                                                    metric={metric}
                                                    height={mapHeight}
                                                />
                                            )}
                                        </MapHeightContainer>
                                        <div className="delivery-map-page__legend">
                                            <HeatLegend maxValue={maxValue} metric={metric} />
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        </Portlet>
                    </div>
                </div>
                {!loading ? <BranchesTable branches={branches} /> : null}
            </Content>
        );
    }
}

const mapStateToProps = (state) => ({
    points: state.deliveryMap.points,
    zones: state.deliveryMap.zones,
    filials: state.handbook.filials,
    branches: state.deliveryMap.branches,
    summary: state.deliveryMap.summary,
    filters: state.deliveryMap.filters,
    cellSize: state.deliveryMap.cellSize,
    metric: state.deliveryMap.metric,
    showZones: state.deliveryMap.showZones,
    loading: state.loaders.deliveryMap
});

const mapDispatchToProps = {
    fetchDeliveryPoints,
    fetchDeliveryZones,
    setDeliveryFilters,
    setDeliveryCellSize,
    setDeliveryMetric,
    setDeliveryShowZones,
    setUIvisible
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryMap);
